export default "__VITE_ASSET__f1818bba__"